import { gql } from '@apollo/client';

export const uiTextFragments = {
  uiText: gql`
    fragment uiText on UiText {
      id
      textKey
      description
      alternateDescription
    }
  `,
};

export const uiMessageFragments = {
  uiMessage: gql`
    fragment uiMessage on UiMessage {
      id
      messageKey
      messageType
      messageButtons
      message
      alternateMessage
    }
  `,
};

export const SEARCH_UI_TEXTS = gql`
  ${uiTextFragments.uiText}
  query SearchUiTexts($searchInput: SearchInput) {
    searchUiTexts(searchInput: $searchInput) {
      items {
        ...uiText
      }
    }
  }
`;

export const SAVE_UI_TEXT = gql`
  ${uiTextFragments.uiText}
  mutation SaveUiTexts($saveUiTextsInput: SaveUiTextsInput!) {
    saveUiTexts(saveUiTextsInput: $saveUiTextsInput) {
      errors {
        messageKeys
      }
      uiTexts {
        ...uiText
      }
    }
  }
`;

export const SEARCH_UI_MESSAGE = gql`
  ${uiMessageFragments.uiMessage}
  query SearchUiMessages($searchInput: SearchInput) {
    searchUiMessages(searchInput: $searchInput) {
      items {
        ...uiMessage
      }
    }
  }
`;

export const SAVE_UI_MESSAGE = gql`
  ${uiMessageFragments.uiMessage}
  mutation SaveUiMessages($saveUiMessagesInput: SaveUiMessagesInput!) {
    saveUiMessages(saveUiMessagesInput: $saveUiMessagesInput) {
      uiMessages {
        ...uiMessage
      }
      errors {
        messageKeys
      }
    }
  }
`;
